import balanceApply from '../../views/ins-manage/ins-balance-apply.vue';
import balanceCheck from '../../views/ins-manage/ins-balance-check.vue';
import balanceCheckDetail from '../../views/ins-manage/ins-balance-check-detail.vue';
import balanceSettle from '../../views/ins-manage/ins-balance-settle.vue';
import balanceSettleDetail from '../../views/ins-manage/ins-balance-settle-detail.vue';
import renewalList from '../../views/ins-manage/ins-renewal.vue';
import renewalDetail from '../../views/ins-manage/ins-renewal-detail.vue';
import renewalDownload from '../../views/ins-manage/ins-renewal-export.vue';
import insOrderQuery from '../../views/ins-manage/ins-order-query.vue';
// import insOrderDetail from '../../views/ins-manage/ins-order-detail.vue'
var insBalance = [
    {
        name: 'insBalanceApply',
        path: 'balance-apply',
        component: balanceApply,
    },
    {
        name: 'insBalanceCheck',
        path: 'balance-check',
        component: balanceCheck,
    },
    {
        name: 'insBalanceCheckDetail',
        path: 'balance-check-detail/:checkOrderId',
        component: balanceCheckDetail,
        props: true,
    },
    {
        name: 'insBalanceSettle',
        path: 'balance-settle',
        component: balanceSettle,
    },
    {
        name: 'insBalanceSettleDetail',
        path: 'balance-settle-detail/:settleOrderId',
        component: balanceSettleDetail,
        props: true,
    },
    {
        name: 'renewal',
        path: 'renewal-list',
        component: renewalList,
    },
    {
        name: 'renewalDetail',
        path: 'renewal-detail/:policyId',
        component: renewalDetail,
        props: true,
    },
    {
        name: 'renewalExportList',
        path: 'renewal-download',
        component: renewalDownload,
    },
    {
        name: 'insOrderQuery',
        path: 'order-query',
        component: insOrderQuery,
    },
];
export default insBalance;
